import { render } from "./TextWithLeadingIcon.vue?vue&type=template&id=21fd36ac&scoped=true&ts=true"
import script from "./TextWithLeadingIcon.vue?vue&type=script&lang=ts"
export * from "./TextWithLeadingIcon.vue?vue&type=script&lang=ts"

import "./TextWithLeadingIcon.vue?vue&type=style&index=0&id=21fd36ac&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fd36ac"]])

export default __exports__